import { Collapse, Typography, Space, Tooltip } from "antd";
import styles from "./styles.module.css";

export const CollapseCorrections = ({ data, sum, width }) => {
  return (
    <Collapse
      expandIcon={width > 640 ? (sum ? undefined : () => null) : () => null}
      expandIconPosition="end"
      collapsible={width > 640 ? (sum ? "header" : "disabled") : "disabled"}
      size="large"
      defaultActiveKey={sum ? [1] : []}
      style={{
        backgroundColor: "#fff",
        marginBottom: 16,
        borderRadius: 2,
        paddingRight: width > 640 ? (sum ? 0 : 30) : 0,
      }}
      className={styles.collapse}
      items={[
        {
          key: 1,
          label: (
            <Space
              direction="horizontal"
              style={{ justifyContent: "space-between", width: "100%" }}
            >
              <Typography.Title
                level={5}
                style={{
                  margin: 0,
                  color: "#1E1E1E",
                  fontWeight: 700,
                }}
              >
                Коррекции:
              </Typography.Title>
              <div
                style={{
                  backgroundColor: `#B7E4C8`,
                  fontSize: width > 640 ? 12 : 10,
                  fontWeight: 700,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minWidth: 102,
                  height: 22,
                  borderRadius: 5,
                  textWrap: "nowrap",
                }}
              >
                {`${
                  sum != null
                    ? sum.toLocaleString("ru-RU").replace("-", "- ")
                    : 0
                } р.` || 0}
              </div>
            </Space>
          ),
          children: sum ? (
            <>
              <div style={{ color: "#2E496F", overflow: "auto" }}>
                <div style={{ minWidth: "600px" }}>
                  {data?.map((item) => {
                    return (
                      <>
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            gap: 20,
                          }}
                          key={item.id}
                        >
                          <div style={{ minWidth: "30%" }}>
                            <Typography.Text
                              style={{
                                fontSize: width > 640 ? 18 : 14,
                                color: "#333333",
                                marginTop: 5,
                                fontWeight: 700,
                              }}
                            >
                              {`${item.cost
                                .toLocaleString("ru-RU")
                                .replace("-", "- ")} р.`}
                            </Typography.Text>
                          </div>
                          <>
                            <div style={{ width: "200px" }}>
                              <Typography.Text
                                style={{
                                  fontSize: width > 640 ? 18 : 14,
                                  color: "#333333",
                                }}
                              >
                                {item?.corr_type}
                              </Typography.Text>
                            </div>
                            <div
                              style={{
                                maxWidth: "200px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              <Tooltip
                                color="#FFFFFF"
                                title={
                                  <span style={{ color: "#4B4F55" }}>
                                    {item?.comment}
                                  </span>
                                }
                              >
                                <Typography.Text
                                  style={{
                                    fontSize: width > 640 ? 18 : 14,
                                    color: "#333333",
                                  }}
                                >
                                  {item?.comment}
                                </Typography.Text>
                              </Tooltip>
                            </div>
                          </>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
            </>
          ) : null,
        },
      ]}
    />
  );
};
